import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';

function transformData(inputData) {
  const categories = ['Low', 'Moderate', 'High', 'Extreme'];
  const assessmentTypes = ['Inherent', 'Residual', 'Future'];

  // Initialize the result array with objects for each assessment type
  const result = assessmentTypes.map(type => ({
    name: type,
    low: 0,
    moderate: 0,
    high: 0,
    extreme: 0
  }));

  // Process each assessment in the input data directly
  inputData.forEach(assessment => {
    const { assessment_type, risk_category, count } = assessment;
    const resultItem = result.find(item => item.name.toLowerCase() === assessment_type.toLowerCase());

    if (resultItem) {
      // Convert risk category to lowercase to match the result object keys
      const categoryKey = risk_category.toLowerCase();
      if (categories.includes(risk_category)) {
        resultItem[categoryKey] += count;
      }
    }
  });

  return result;
}

const RiskSummaryReport = ({ height, data, type }) => {
  // Safely extract the relevant array based on `type`
  const inputData = data[type.toLowerCase()];

  // If no matching data is found, default to an empty array to avoid errors
  const transformedData = Array.isArray(inputData)
    ? transformData(inputData)
    : [];

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={transformedData}
        margin={{
          top: 15,
          right: 10,
          left: 10,
          bottom: 0,
        }}
      >
        <XAxis dataKey="name" />
        <YAxis hide />
        <Tooltip />
        <Legend layout="horizontal" verticalAlign="top" align="center" />
        <Bar dataKey="low" fill="#05769d">
          <LabelList dataKey="low" position="insideTop" style={{ fill: 'black' }} formatter={(value) => (value !== 0 ? value : '')} />
        </Bar>
        <Bar dataKey="moderate" fill="#09A6B0">
          <LabelList dataKey="moderate" position="insideTop" style={{ fill: 'black' }} formatter={(value) => (value !== 0 ? value : '')} />
        </Bar>
        <Bar dataKey="high" fill="#FED4AE">
          <LabelList dataKey="high" position="insideTop" style={{ fill: 'black' }} formatter={(value) => (value !== 0 ? value : '')} />
        </Bar>
        <Bar dataKey="extreme" fill="#F07167">
          <LabelList dataKey="extreme" position="insideTop" style={{ fill: 'black' }} formatter={(value) => (value !== 0 ? value : '')} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RiskSummaryReport;